import { render, staticRenderFns } from "./TabelaOrdemDeCorte.vue?vue&type=template&id=799493f5&lang=pug"
import script from "./TabelaOrdemDeCorte.vue?vue&type=script&lang=js"
export * from "./TabelaOrdemDeCorte.vue?vue&type=script&lang=js"
import style0 from "./TabelaOrdemDeCorte.vue?vue&type=style&index=0&id=799493f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports